/*
 * ymm-core: the ONE place for shared vehicle ("My Garage") logic.
 * Loaded BLOCKING in layout/theme.liquid <head> so both deferred assets and inline
 * parse-time scripts can use it. No DOM work here — pure helpers only.
 *
 *   NewarkYMM.getVehicle()            -> {make, model, year} | null   (localStorage newark_garage_v1)
 *   NewarkYMM.label(v)                -> "1961 Mercedes-Benz 190SL"
 *   NewarkYMM.vehicleParams(v, p, o)  -> adds the vehicle filter params to a URLSearchParams
 *   NewarkYMM.searchUrl(v, o)         -> "/collections/all?filter.p.m.filters.make=…"
 *                                        (NOT /search: Shopify's search index lags after bulk product
 *                                        edits and silently drops fitting products; collection
 *                                        filtering reads live data — 2026-09-17)
 *   NewarkYMM.fits(fit, v)            -> does a product's fitment cover the vehicle?
 *   NewarkYMM.esc(s), NewarkYMM.money(amount, format)
 *
 * URL contract (Shopify Search & Discovery metafield filters, namespace `filters`):
 *   full triple  -> make + exact `mmy` "Make|Model|Year" ONLY (a model param would exclude
 *                   multi-application products whose single-value model field is blank)
 *   partial      -> make + model and/or years
 */
(function () {
  // Legacy vehicle pages lived at /search?q=*&filter…make=… — send them to /collections/all
  // (same filters, live data). Typed searches (q != *) are untouched.
  try {
    if (location.pathname.indexOf('/search') === 0) {
      var lp = new URLSearchParams(location.search);
      if (lp.get('q') === '*' && lp.has('filter.p.m.filters.make')) {
        lp.delete('q'); lp.delete('type'); lp.delete('options[prefix]');
        location.replace('/collections/all?' + lp.toString());
      }
    }
  } catch (e) {}

  var KEY = 'newark_garage_v1';

  function getVehicle() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }

  function label(v) {
    return v ? [v.year, v.make, v.model].filter(Boolean).join(' ') : '';
  }

  // opts.years = [y0, y1]: one mmy per year of a range (same-key params are OR'd).
  function vehicleParams(v, p, opts) {
    opts = opts || {};
    p = p || new URLSearchParams();
    if (!v || !v.make) return p;
    p.set('filter.p.m.filters.make', v.make);
    if (opts.years && v.model) {
      for (var y = opts.years[0]; y <= opts.years[1]; y++) p.append('filter.p.m.filters.mmy', v.make + '|' + v.model + '|' + y);
    } else if (v.model && v.year) {
      p.set('filter.p.m.filters.mmy', v.make + '|' + v.model + '|' + v.year);
    } else {
      if (v.model) p.set('filter.p.m.filters.model', v.model);
      if (v.year) p.set('filter.p.m.filters.years', v.year);
    }
    return p;
  }

  // opts.productType narrows to one product type; opts.years as in vehicleParams.
  function searchUrl(v, opts) {
    opts = opts || {};
    var p = new URLSearchParams();
    vehicleParams(v, p, opts);
    if (opts.productType) p.set('filter.p.product_type', opts.productType);
    return '/collections/all?' + p.toString();
  }

  function list(x) {
    if (x === null || x === undefined || x === '') return [];
    return Array.isArray(x) ? x.map(String) : [String(x)];
  }
  function hasCI(arr, val) {
    var t = String(val || '').trim().toLowerCase();
    return arr.some(function (x) { return String(x).trim().toLowerCase() === t; });
  }

  // fit = { mmy, make, model, years } (strings or arrays, as stored in the `filters.*`
  // metafields). Needs a complete vehicle. Exact mmy triple wins; "Make|All|Year" covers
  // make-wide material lines; products not yet backfilled with mmy use the separate fields.
  function fits(fit, v) {
    if (!fit || !v || !v.make || !v.model || !v.year) return false;
    var mmy = list(fit.mmy);
    if (mmy.length) {
      return hasCI(mmy, v.make + '|' + v.model + '|' + v.year) || hasCI(mmy, v.make + '|All|' + v.year);
    }
    var models = list(fit.model);
    return hasCI(list(fit.make), v.make) && (hasCI(models, v.model) || hasCI(models, 'All')) && hasCI(list(fit.years), v.year);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // amount in dollars (string or number). Uses the theme's formatMoney when loaded.
  function money(amount, format) {
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    var cents = Math.round(n * 100);
    if (typeof formatMoney === 'function') return formatMoney(cents, format || '${{amount}}');
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  window.NewarkYMM = {
    KEY: KEY, getVehicle: getVehicle, label: label, vehicleParams: vehicleParams,
    searchUrl: searchUrl, fits: fits, hasCI: hasCI, list: list, esc: esc, money: money,
  };
})();
